var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkontakteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2787F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6702 5.69768C12.7378 5.48617 12.6702 5.33075 12.3484 5.33075H11.2843C11.0137 5.33075 10.8889 5.46501 10.8213 5.61306C10.8213 5.61306 10.2801 6.85038 9.51354 7.65411C9.26554 7.88678 9.1528 7.96078 9.01754 7.96078C8.94987 7.96078 8.85194 7.88678 8.85194 7.67524V5.69768C8.85194 5.44387 8.7734 5.33075 8.54794 5.33075H6.87574C6.70667 5.33075 6.60497 5.44855 6.60497 5.5602C6.60497 5.8008 6.98827 5.85629 7.02774 6.53313V8.00311C7.02774 8.32538 6.96574 8.38384 6.8304 8.38384C6.46968 8.38384 5.59218 7.14098 5.07173 5.71882C4.96974 5.4424 4.86744 5.33075 4.59548 5.33075H3.53135C3.22732 5.33075 3.1665 5.46501 3.1665 5.61306C3.1665 5.87745 3.52727 7.18878 4.84627 8.92318C5.7256 10.1076 6.96454 10.7496 8.09187 10.7496C8.76827 10.7496 8.852 10.607 8.852 10.3614V9.46624C8.852 9.18104 8.91607 9.12411 9.13027 9.12411C9.28807 9.12411 9.55867 9.19811 10.19 9.76918C10.9115 10.446 11.0305 10.7496 11.4363 10.7496H12.5004C12.8045 10.7496 12.9565 10.607 12.8687 10.3256C12.7728 10.0452 12.4283 9.63824 11.9712 9.15584C11.7232 8.88084 11.3511 8.58478 11.2384 8.43671C11.0806 8.24638 11.1257 8.16171 11.2384 7.99251C11.2384 7.99251 12.5349 6.27932 12.6702 5.69768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakteCircle);
export default __webpack_public_path__ + "static/media/vkontakteCircle.58d060f669120de9e3a86a43defa7e69.svg";
export { ForwardRef as ReactComponent };